import React, { useEffect, useState } from "react";
import Introduction from "./common/Introduction";
import GeneralResults from "./multipleCriterias/GeneralResults";
import FeedbacksContainer from "./common/FeedbacksContainer";
import Footer from "./common/Footer";
import NoResults from "./NoResults";
import { translate } from "utlis/translations/i18n";

const MultipleCriteriasResults = ({
  session,
  results,
  feedbacks,
  instances,
}) => {
  const [playedTimes, setPlayedTimes] = useState("");
  //Ce state est utilisé pour stocker le nom du participant sélectionné dans le menu déroulant de Introduction.js
  const [selectedName, setSelectedName] = useState(null);

  useEffect(() => {
    var obj = results[0];
    const numberOfVotes = obj ? obj[Object.keys(obj)[1]].numberOfVotes : "0";
    setPlayedTimes(numberOfVotes);
    // eslint-disable-next-line
  }, []);

  if (playedTimes === "0") return <NoResults />;

  return (
    <div className="new-results">
      <Introduction
        session={session}
        protocol={translate("multipleCriterias")}
        playedTimes={playedTimes}
        onSelectName={setSelectedName}
        results={results}
      />
      <GeneralResults
        results={results}
        session={session}
        playedTimes={playedTimes}
        selectedName={selectedName}
      />
      {feedbacks && feedbacks.length ? (
        <FeedbacksContainer feedbacks={feedbacks} selectedName={selectedName} />
      ) : (
        <></>
      )}
      <Footer />
    </div>
  );
};

export default MultipleCriteriasResults;
